import { SHOPIFY_APP_LISTING_URL } from "./src/data/site";

const CRISP_WEBSITE_ID = "f7a34873-07fc-45ca-8d85-c9a202384775";
const CRISP_SCRIPT_SRC = "https://client.crisp.chat/l.js";

const pushCrispSessionData = () => {
  window.$crisp.push([
    "set",
    "session:data",
    [
      [
        ["source", "useservd.com"],
        ["surface", "marketing_site"],
        ["page_path", window.location.pathname],
      ],
    ],
  ]);
  window.$crisp.push(["set", "session:segments", [["marketing-site"]]]);
};

// Every install button links to the App Store listing. One capture-phase
// listener tags the link with the page it was clicked on and reports an
// install_click event to GA4 (gtag is only loaded in production builds).
const trackInstallClick = (event) => {
  const link = event.target.closest?.(`a[href^="${SHOPIFY_APP_LISTING_URL}"]`);
  if (!link) {
    return;
  }

  const url = new URL(link.href);
  url.searchParams.set("utm_content", window.location.pathname);
  link.href = url.toString();

  if (typeof window.gtag === "function") {
    window.gtag("event", "install_click", {
      page_path: window.location.pathname,
      link_text: link.textContent.trim().slice(0, 100),
    });
  }
};

export const onClientEntry = () => {
  document.addEventListener("click", trackInstallClick, true);

  window.$crisp = window.$crisp || [];
  window.CRISP_WEBSITE_ID = window.CRISP_WEBSITE_ID || CRISP_WEBSITE_ID;

  pushCrispSessionData();

  if (document.querySelector(`script[src="${CRISP_SCRIPT_SRC}"]`)) {
    return;
  }

  const script = document.createElement("script");
  script.src = CRISP_SCRIPT_SRC;
  script.async = true;
  document.head.appendChild(script);
};

export const onRouteUpdate = () => {
  if (!window.$crisp) {
    return;
  }

  pushCrispSessionData();
};
